<div class="card shadow-sm h-100 news-card">
  <div class="card-body px-4 py-4">

    <div class="d-flex align-items-start flex-row ">

     
      <img
        [src]="preferenceItem.image|| '/assets/images/no-image.svg'"
        (error)="onImgError($event)"
        class="news-img rounded"
        alt="news image"
      />
      

      <div class="news-content ms-3">
        <a class="text-decoration-none text-reset d-block" [href]="preferenceItem?.url" target="_blank">
          <h5 class="fs-5 mb-1 news-title">{{ preferenceItem.title }}</h5>

          <p
            class="fs-6 text-gray-500 mb-0 truncate-2-line"
            [innerHTML]="preferenceItem?.body"
          ></p>
        </a>

        <div class="mt-3 ">
          <div class="d-flex gap-3 flex-wrap align-items-center text-hover-primary">
            <!-- <span class="fw-bold text-gray-600 text-hover-primary ml-2 ">Courtesy: </span> -->
            <span class="text-gray-600 ml-2 text-hover-primary fw-bold"> {{ preferenceItem?.source_title }}</span>
          </div>

          <div class="d-flex gap-2 align-items-center mt-2 flex-wrap" style="justify-content: space-between;">
            <span class=" text-gray-600 p-2 text-hover-primary cursor-pointer "
            >
              <i class="bi bi-calendar-date me-1"></i>
              {{ preferenceItem?.dateTime | date:'medium' }}
            </span>

            <span
              (click)="onCategoryClick()"
              class="badge badge-secondary bg-light text-gray-600 p-2 text-hover-primary  cursor-pointer"
            >
              <i class="bi bi-tag-fill me-1"></i>
              {{ preferenceItem?.category?.name || 'N/A' }}
            </span>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

